import _get from 'lodash/get'
import mapGet from '../../libs/mapGet'

export default {
  computed: {
    certs() {
      if (this.job.cert) {
        return this.job.cert
      }
      return []
    },
    education() {
      return _get(this.job, 'education_requirement.name') || ''
    },
    skills() {
      return mapGet(this.job.skill, 'name').filter((skill) => skill) // Filter out empty skill name
    },
    spokenSkills() {
      if (Array.isArray(this.job.spoken_skill)) {
        return this.job.spoken_skill.filter((skill) => skill && skill.name && skill.level)
      }
      return []
    },
    writtenSkills() {
      if (Array.isArray(this.job.written_skill)) {
        return this.job.written_skill.filter((skill) => skill && skill.name && skill.level)
      }
      return []
    },
  },
  props: {
    job: {
      required: true,
      type: Object,
    },
  },
}
